﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../Cadenas/Cadenas";
import { catCanales } from "../Categorias y Estados/catCanales";

const columns = () =>
(
    {
        c_grupoempresa_id: new EntityColumn<string>({ name: 'c_grupoempresa_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Grupo ID' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_canales: new EntityColumn<string[]>({ name: 'vc_canales', type: 'varchar', flags: c.Edit, prompt: 'Canales', isArray: true }),
        vc_cadenas: new EntityColumn<string[]>({ name: 'vc_cadenas', type: 'varchar', flags: c.Edit, prompt: 'Cadenas', isArray: true }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        grem_brwStandard: { name: 'grem_brwStandard', keyMappings: { c_grupoempresa_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        }

    }
)
export class GruposEmpresasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('GruposEmpresas');
    }
}